export const seriesTrendsKeys = {
  closureTrend: "closure_trend",
  pushTrend: "push_trend",
  hprTrend: "hpr_trend",
  bwatTrend: "bwat_trend"
};
